export default __webpack_public_path__ + "static/media/stok-opname.274098bd.png";